import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { Language } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TInnerData = {
  allOrderableTargetLanguages: Language[];
};

type TData = string[];

export const useAllOrderableTargetLanguagesCodes = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query languages {
      clientAccount {
        allOrderableTargetLanguages {
          code
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useAllOrderableTargetLanguagesCodes'],
    queryFn: async () =>
      (
        (await client.request({
          data: {
            gql: graphql
          }
        })) as TInnerData
      )?.allOrderableTargetLanguages?.map((lang) => lang?.code)
  });
};
